import React, { useState, useRef, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  useTheme,
  Button,
  Stack,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import { useSelector } from "react-redux";
import { useGetTenantPicture, useAddTenantPicture } from "../../../scenes/CompanyManagment/Hooks";
import Delete from "@mui/icons-material/Delete";
import SaveIcon from '@mui/icons-material/Save';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";

const ImageTenantSelector = ({
  setChangeImgData,
  imageSelectedType,

  setShowToastMessage,
  fillPadd,
  AddButtonVariant,
  addButtonColor,
  directionImageWrap,
  disableSizeText
}: any) => {
  const [selectedFile, setSelectedFile] = useState<any>({
    picture: null,
    imageName: '',
    title: '',
    url: '',
  });
  const [open, setOpen] = useState(false);
  const [authorizedFiles, setAuthorizedFiles] = useState<string | null>(null);
  const tenantId: string = useSelector((state: any) => state.meetings.profileTenantId);
  const { data: personPictureData } = useGetTenantPicture(tenantId);

  const { mutate: addPersonImg, isLoading, data, error } = useAddTenantPicture(() => {
    setSelectedFile({
      picture: null,
      imageName: '',
      title: '',
      url: '',
    });
  });

  const theme = useTheme();
  const fileRef = useRef<HTMLInputElement | null>(null);

  const handleSetImages = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;

    if (file) {
      if (file.type.includes("image/") && ["png", "jpeg", "jpg", "svg+xml"].includes(file.type.split("/")[1]) && file.size <= 4000000) {
        let imgFile = {
          picture: file,
          imageName: file.name,
          title: file.name,
          url: URL.createObjectURL(file),
        };
        setSelectedFile(imgFile);
        setAuthorizedFiles(null);
      } else {
        setAuthorizedFiles('فایل غیر مجاز است');
      }
    }
  };

  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.picture);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleUpload = async () => {
    if (selectedFile.picture !== null) {
      try {
        const base64String = await convertToBase64(selectedFile);
        let body = {
          tenantId: tenantId,
          extension: selectedFile.picture.type === "image/svg+xml" ? '.svg' : '.png',
          PictureBase64String: base64String
        };
        await addPersonImg(body);
        setOpen(false);
        setShowToastMessage("عملیات موفقیت‌آمیز بود");
      } catch (error) {
        console.error('Error uploading file:', error);
        setShowToastMessage("خطای سرور: لطفاً دوباره تلاش کنید");
      }
    }
  };

  useEffect(() => {
    if (data) {
      setChangeImgData(data);
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      setShowToastMessage("خطای سرور: لطفاً دوباره تلاش کنید");
    }
  }, [error]);

  return (
    <Grid
      container
      pb={fillPadd ? fillPadd : 0}
      pt={1}
      px={1}
      sx={{
        borderRadius: "8px",
        background: theme.palette.mode === "dark" ? "transparent" : "transparent",
        boxShadow: theme.palette.mode === "dark" ? "none" : "none",
      }}
    >
      <Grid item xs={12} md={12} py={1}>
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
          <IconButton
            onClick={() => setOpen(true)}
            sx={{
              fontSize: 60,
              backgroundColor: theme.palette.primary.main,
              color: "#fff",
              '&:hover': {
                backgroundColor: theme.palette.primary.dark,
              },
              borderRadius: "50%",
              boxShadow: `0 4px 8px ${theme.palette.grey[600]}`,
            }}
          >
            <AddPhotoAlternateIcon />
          </IconButton>
        </Box>
      </Grid>

      <Dialog 
        open={open} 
        onClose={() => setOpen(false)}
        PaperProps={{ 
          sx: { 
            backgroundColor: theme.palette.background.paper, 
            boxShadow: "0 6px 12px rgba(0, 0, 0, 0.2)",
            width: "100%", 
            maxWidth: "600px",
            borderRadius: "16px",
          } 
        }}
        maxWidth="sm"
      >
        <DialogTitle sx={{ padding: "16px", fontSize: "18px", fontWeight: "bold" }}>
          افزودن
        </DialogTitle>
        <DialogContent sx={{ padding: "16px" }}>
          <Stack
            direction={"column"}
            alignItems={"center"}
            spacing={2}
          >
            <Button
              variant={AddButtonVariant || "contained"}
              color={addButtonColor || "primary"}
              sx={{ px: "16px", borderRadius: "8px" }}
              onClick={() => fileRef.current?.click()}
            >
              {imageSelectedType === 1 ? "انتخاب فایل" : "افزودن"}
            </Button>
            <input
              hidden
              ref={fileRef}
              type="file"
              accept="image/png, image/jpeg, image/jpg, image/svg+xml"
              onChange={(event) => {
                handleSetImages(event);
              }}
            />
            {selectedFile.picture ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <img
                  src={selectedFile.url}
                  alt="Selected"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "400px",
                    borderRadius: '8px',
                    boxShadow: `0 4px 8px ${theme.palette.grey[400]}`,
                    objectFit: 'contain',
                    marginBottom: "16px",
                  }}
                />
                <Stack
                  direction={"row"}
                  spacing={1}
                  width={"100%"}
                  justifyContent={"center"}
                >
                  <IconButton
                    onClick={() => setSelectedFile({
                      picture: null,
                      imageName: '',
                      title: '',
                      url: '',
                    })}
                    sx={{
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      '&:hover': {
                        backgroundColor: theme.palette.error.light,
                      }
                    }}
                  >
                    <Delete />
                  </IconButton>
                </Stack>
              </Box>
            ) : authorizedFiles !== null ? (
              <Box
                textAlign={"center"}
                flexDirection={"column"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                width={"100%"}
                height={"100%"}
              >
                <Typography color={"red"} variant="button">
                  {authorizedFiles}
                </Typography>
                <ErrorOutlineIcon color="error" />
              </Box>
            ) : (
              <Stack
                direction={directionImageWrap || "column"}
                rowGap={2}
                alignItems={"center"}
                py={1}
              >
                <Typography color={"gray"} fontSize={"12px"}>
                  فایل‌های مجاز: PNG, JPEG, JPG, SVG
                </Typography>
                {disableSizeText ? "" : (
                  <Typography
                    color={"gray"}
                    className="font-num"
                    fontSize={"12px"}
                  >
                    حداکثر حجم: 4 مگابایت
                  </Typography>
                )}
              </Stack>
            )}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ padding: "16px" }}>
          <Button onClick={() => setOpen(false)} color="primary">
            بستن
          </Button>
          <Button
            disabled={selectedFile.picture === null || isLoading}
            onClick={handleUpload}
            endIcon={<SaveIcon />}
            color="primary"
          >
            ذخیره
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default ImageTenantSelector;
